// utils
import axios from 'axios';
import { url } from '../../../utils/urls';

// api parameters
const withCredentials = true;
const headers = {
    'Content-Type': 'application/json'
};

// api requests
export const getProductDataLastUpdatedRequest = (product) => 
    axios.get(`${url.pa.url}/v1/last-updated?product=${product || 'COMMENTING'}`, { headers, withCredentials });

//commenting
export const postTotalCommentsRequest = ({ interval, requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.totalComments}?interval=${interval}`, requestData, { headers, withCredentials });

export const postTotalCommentingViewsRequest = ({ interval, requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.url}/total-commenting-views`, requestData, { headers, withCredentials });

export const postCommentingUsersRequest = ({ requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.commentingUsers}`, requestData, { headers, withCredentials });

export const postTotalCommentingReactionsRequest = ({ requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.totalReactions}`, requestData, { headers, withCredentials });

export const postTopArticlesRequest = ({ requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.url}/popular-articles`, requestData, { headers, withCredentials });

export const postCommentingBeelineRequest = ({ requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.commentingBeeline}`, requestData, { headers, withCredentials });

export const postEmailsSentRequest = ({ requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.emailsSent}`, requestData, { headers, withCredentials });

export const postTopArticlesExportAllRequest = ( requestData ) =>
    axios.post(`${url.pa.commentingAnalytics.url}/export-popular-articles`, requestData, { headers, withCredentials });

export const postCommentingAvgInViewData = ({ interval, requestData }) =>
    axios.post(`${url.pa.commentingAnalytics.url}/average-in-view`, requestData, { headers, withCredentials });

// trivia
export const postTopCardsRequest = ({ requestData }) =>
    // axios.post(`${hunchmeurl + topPollsUrl}`, requestData, { headers, withCredentials });
    axios.post(`${url.pa.triviaAnalytics.topCards}`, requestData, { headers, withCredentials });

export const postTotalAnswersRequest = (requestData) =>
    axios.post(`${url.pa.triviaAnalytics.totalAnswers}`, requestData, { headers, withCredentials });

export const postUniqueTriviaUsersRequest = ({ requestData }) =>
    axios.post(`${url.pa.triviaAnalytics.uniqueTriviaUsers}`, requestData, { headers, withCredentials });

export const postTriviaEngagementRateRequest = ({ requestData }) =>
    axios.post(`${url.pa.triviaAnalytics.triviaEngagementRate}`, requestData, { headers, withCredentials });

export const postTopSkippedRequest = ({ requestData }) =>
    axios.post(`${url.pa.triviaAnalytics.url}/top-skipped-cards`, requestData, { headers, withCredentials });

export const postTopSkippedCardsExportAllRequest = ( requestData ) =>
    axios.post(`${url.pa.triviaAnalytics.topSkippedExport}`, requestData, { headers, withCredentials });

export const postTopPollsExportAllRequest = ( requestData ) =>
    axios.post(`${url.pa.triviaAnalytics.topCardsExport}`, requestData, { headers, withCredentials });

export const postTriviaAvgInViewData = ( requestData ) =>
    axios.post(`${url.pa.triviaAnalytics.url}/average-in-view`, requestData, { headers, withCredentials });

export const postTrendingNowPageViewRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/trending-now-analytics/trending-now-page-loads`, requestData, { headers, withCredentials }); 

export const postTrendingNowTotalClicksRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/trending-now-analytics/trending-now-clicks`, requestData, { headers, withCredentials }); 

export const postTrendingNowTopArticlesRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/trending-now-analytics/popular-articles`, requestData, { headers, withCredentials }); 

export const postTrendingNowTopArticlesExportAllRequest = ( requestData ) =>
    axios.post(`${url.pa.url}/v1/trending-now-analytics/export-popular-articles`, requestData, { headers, withCredentials });

export const postTrendingNowAvgInViewRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/trending-now-analytics/trending-now-in-view-rate`, requestData, { headers, withCredentials }); 

export const postTrendingNowTotalEmbedLoadsRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/trending-now-analytics/trending-now-embed-views`, requestData, { headers, withCredentials }); 

export const postTrendingNowGeneratedPageViewsRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/trending-now-analytics/trending-now-generated-page-views`, requestData, { headers, withCredentials }); 


// ARTICLE SENTIMENT ANALYTICS
export const postArticleSentimentReactionClickRateRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/article-sentiment-analytics/reaction-click-rate`, {...requestData}, { headers, withCredentials }); 

export const postArticleSentimentReactionClicksRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/article-sentiment-analytics/reaction-clicks`, {...requestData}, { headers, withCredentials }); 

export const postArticleSentimentPopularArticlesRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/article-sentiment-analytics/popular-articles`, {...requestData}, { headers, withCredentials }); 

export const postArticleSentimentExportPopularArticlesRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/article-sentiment-analytics/export-popular-articles`, {...requestData}, { headers, withCredentials }); 

export const postArticleSentimentInViewRateRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/article-sentiment-analytics/in-view-rate`, {...requestData}, { headers, withCredentials }); 

export const postArticleSentimentTotalEmbedLoadsRequest = ({ requestData }) => 
    axios.post(`${url.pa.url}/v1/article-sentiment-analytics/embed-loads`, {...requestData}, { headers, withCredentials }); 
